import { useAuth0 } from "@auth0/auth0-react";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import deceasedPhoto from "assets/icons/speaker.svg";
import { useFormik } from "formik";
import { useDisableEnterKey } from "hook";
import CommunicationService from "Lib/API/Communication/index";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { setCreateAutomationDialog } from "services/api/communication";
import { CreatedAutomationDone } from "./CreatedAutomationDone/CreatedAutomationDone";
import { MyTemplate } from "./MyTemplate/MyTemplate";
import { NewAutomation } from "./NewAutomation";
import { NewTemplate } from "./NewTemplate/NewTemplate";
import { TextMessege } from "./TextMessege/TextMessege";
import { Content, Image, StepperWrapper, Wrapper } from "./Theme";

export const CreateAutomation = ({ setToggle,setRefresh,refresh}) => {
  const { getAccessTokenSilently } = useAuth0();
  const [dropDownType, setDropDownType] = useState([]);
  const [open, setOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [cardName, setCardName] = useState("");
  const { selectedAudienceRows } = useSelector((state) => state.communication);
  const { selectedTemplate } = useSelector((state) => state.communication);
  const { cardContent, automationEditData } = useSelector(
    (state) => state.communication
  );
  const countTotalCampaign = selectedAudienceRows.map((val) =>
    cardName === "sms" ? val.numberOfPhones : val.numberOfEmails
  );
  const sum = countTotalCampaign?.reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0
  );
  const campaignDoneDetails =
    cardName === "sms" || cardName === "push"
      ? [`Automation has total ${sum} people`]
      : [
          `Automation has total ${sum} people`,
          `"${
            Object.keys(selectedTemplate).length > 0
              ? selectedTemplate?.title
              : automationEditData?.template?.title
          }" has been selected`,
        ];
  const dispatch = useDispatch();
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      automationName: automationEditData?.automationName,
      eventType: "",
      subject:automationEditData?.subject || "",
      account: {
        audiences: automationEditData?.audiences?.map((item) => {
          return {
            title: item?.name,
            id: item?._id,
            ...item,
          };
        }),
      },
      timeExecute: {
        timeType:  automationEditData?.timeExecute?.timeType ? automationEditData?.timeExecute?.timeType === "before"
        ? "Before"
        : automationEditData?.timeExecute?.timeType === "after"
        ? "After"
        : "On The Day"
        :"Before",
        unit: automationEditData?.timeExecute?.unit || 1,
        timePeriod: automationEditData?.timeExecute?.timePeriod || "Day",
      },
    },
  });

  const getEventTypes = async () => {
    const token = await getAccessTokenSilently();
    try {
      const response = await CommunicationService.getEventTypesList(token);
      const resultData = response?.result?.map((val) => {
        return {
          label: val?.title,
          value: val?.title,
          templateType: val?.templateType,
        };
      });
      if(automationEditData?.eventType) {
        const result = resultData.find((item) => item.value === automationEditData?.eventType);
        formik.setFieldValue("eventType", result);
      }
      setDropDownType(resultData);
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Something went wrong");
    }
  };

  useEffect(() => {
    getEventTypes();
  }, []);

  useDisableEnterKey(true);


  const handleReset = () => {
    formik.resetForm({
      values: {
        automationName: "",
        eventType: "",
        account: {
          audiences: [],
        },
        timeExecute: {
          timeType: "",
          unit: 1,
          timePeriod: "",
        },
      },
    });
  };
  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };
  const handleClose = () => {
    setOpen(false);
    setActiveStep(null); // Reset to the first step
    setToggle("Campaigns");
  };
  const renderContentCards = () => {
    switch (cardContent) {
      case "New template":
        return (
          <NewTemplate
            onNext={handleNext}
            formik={formik}
            cardContent={cardContent}
            activeStep={activeStep}
            onBack={handleBack}
            setActiveStep={setActiveStep}
            setCardName={setCardName}
            eventTypes={dropDownType}
          />
        );
      case "My template":
        return (
          <MyTemplate
            onNext={handleNext}
            onBack={handleBack}
            cardContent={cardContent}
            formik={formik}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            setCardName={setCardName}
            handleResetFormik={handleReset}
            eventTypes={dropDownType}
          />
        );
      case "Text message":
        return (
          <TextMessege
            onNext={handleNext}
            onBack={handleBack}
            onClose={handleClose}
            formik={formik}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            setCardName={setCardName}
            eventTypes={dropDownType}
          />
        );
      case "Push notification":
        return (
          <TextMessege
            onNext={handleNext}
            onBack={handleBack}
            onClose={handleClose}
            formik={formik}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            setCardName={setCardName}
            eventTypes={dropDownType}
            automationType="push"
          />
        );
      case "Done":
        return (
          <CreatedAutomationDone
            onBack={handleBack}
            onClose={handleClose}
            formik={formik}
            text={`${formik.values?.automationName} Successfully Created`}
            details={campaignDoneDetails}
            setCampaignModal={() => dispatch(setCreateAutomationDialog(false))}
            cardName={cardName}
            setToggle={setToggle}
            setRefresh={setRefresh}
            refresh={refresh}
            dropDownType={dropDownType}
          />
        );
      default:
        return (
          <NewAutomation formik={formik} handleResetFormik={handleReset} />
        );
    }
  };

  return (
    <Wrapper>
      <Image>
        <img src={deceasedPhoto} alt="deceased" />
      </Image>
      <Content>
        {cardContent !== "Done" && (
          <StepperWrapper>
            <div
              className="class__steps"
              style={{ width: "39rem", marginBottom: "20px" }}
            >
              <Stepper activeStep={activeStep}>
                <Step className="step">
                  <StepLabel className="step-label">create  Automation</StepLabel>
                </Step>
                <Step>
                  <StepLabel>Edit</StepLabel>
                </Step>
                <Step>
                  <StepLabel>Send</StepLabel>
                </Step>
              </Stepper>
            </div>
          </StepperWrapper>
        )}

        <div className="filter-container">{renderContentCards()}</div>
      </Content>
    </Wrapper>
  );
};
